import { AdresseForm } from '@mairistem/adresses';

import type { AdresseType } from '@/types';

interface PosteComptableAdresseListItemFormProps {
  adresse: AdresseType;
  onChange: (e) => void;
}

const PosteComptableAdresseListItemForm = (props: PosteComptableAdresseListItemFormProps) => {
  const { adresse, onChange } = props;

  return (
    <AdresseForm
      adresse={{
        ...adresse,
        type: adresse?.type === 'Hors commune' ? 'Hors Commune' : adresse?.type,
      }}
      onChange={onChange}
      onItemChange={(data) => {
        onChange({ target: { name: 'adresse', value: data?.adresse } });
      }}
    />
  );
};

export default PosteComptableAdresseListItemForm;
